import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import Dialog, {DialogActions,  DialogContent, DialogContentText, DialogTitle} from 'material-ui/Dialog';
import {BackDropCMS} from '../../../../components/backdrop/backdrop_cms';

class EnableDialog extends Component {

    render() {
        const {
            open,
            handleEnable,
            handleCloseDialog,
            classes
        } = this.props;

        return (
            <Dialog
                maxWidth="md"
                open={open}
                disableBackdropClick={true}
                BackdropComponent={BackDropCMS}
            >
                <DialogTitle>Enable Section</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to enable this section?
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button onClick={(ev) => handleCloseDialog(ev)} variant="raised" autoFocus>
                        Cancel
                    </Button>
                    <Button onClick={(ev) => handleEnable(ev)} color="primary" variant="raised">
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

EnableDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleEnable: PropTypes.func.isRequired,
};

export default EnableDialog;


// WEBPACK FOOTER //
// ./src/containers/templates/builder/form/EnableDialog.jsx